import React from 'react'
import { ProductImageWrapper } from '../../components/product-images-generator/styles'

export const Casement23Square4TopCasement = () => {
  return (
    <ProductImageWrapper>
      <svg
        width="449"
        height="333"
        viewBox="0 0 449 333"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#4-top-2-3filter0_d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32 256C32 254.895 31.1046 254 30 254C28.8954 254 28 254.895 28 256V270.56H32V256ZM32 270.56H28V272.4H27.9399C27.4208 272.4 27 272.821 27 273.34V275.12C27 276.158 27.8417 277 28.8799 277H30.1201C31.1583 277 32 276.158 32 275.12V272.4V272.4V270.56Z"
            fill="white"
          />
        </g>
        <rect
          width="3.99998"
          height="0.95833"
          transform="matrix(-1 0 0 1 32 271.25)"
          fill="#ABABAB"
        />
        <path
          d="M32 254.94C32 254.421 31.5792 254 31.0601 254H28.94C28.4208 254 28 254.421 28 254.94V271.25H32V254.94Z"
          fill="url(#4-top-2-3paint0_linear)"
        />
        <path
          d="M32 276.06C32 276.579 31.5792 277 31.0601 277H27.94C27.4208 277 27 276.579 27 276.06V273.148C27 272.629 27.4208 272.208 27.94 272.208H32V276.06Z"
          fill="url(#4-top-2-3paint1_linear)"
        />
        <g filter="url(#4-top-2-3filter1_d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32 139.999C32 138.895 31.1048 138 30.0005 138C28.8962 138 28.001 138.895 28.001 139.999V142.167H28.001V153H28V156.001C28 157.105 28.8952 158 29.9995 158C31.1038 158 31.999 157.105 31.999 156.001V153.833H32V143H32V139.999Z"
            fill="url(#4-top-2-3paint2_linear)"
          />
        </g>
        <rect
          width="3.99896"
          height="11.6667"
          transform="matrix(-1 0 0 1 32 142.167)"
          fill="#ABABAB"
        />
        <path
          d="M32 138.94C32 138.421 31.5792 138 31.0601 138H28.941C28.4219 138 28.001 138.421 28.001 138.94V143H32V138.94Z"
          fill="url(#4-top-2-3paint3_linear)"
        />
        <path
          d="M28 157.06C28 157.579 28.4208 158 28.9399 158H31.059C31.5781 158 31.999 157.579 31.999 157.06V153H28V157.06Z"
          fill="url(#4-top-2-3paint4_linear)"
        />
        <rect
          width="3.99896"
          height="8.33334"
          transform="matrix(-1 0 0 1 32 143.833)"
          fill="url(#4-top-2-3paint5_linear)"
        />
        <g filter="url(#4-top-2-3filter2_d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M152 128H32V287H152V128ZM141 139H43V276H141V139Z"
            fill="#E8EAEE"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M152 128H32V287H33V129H151V287H152V128Z"
          fill="#FBFBFB"
        />
        <rect
          x="36.53"
          y="132.53"
          width="110.94"
          height="149.94"
          stroke="#E2E4E8"
          strokeWidth="0.93994"
        />
        <g filter="url(#4-top-2-3filter3_i)">
          <rect
            x="43.47"
            y="139.47"
            width="97.0601"
            height="136.06"
            stroke="#979797"
            strokeWidth="0.93994"
          />
        </g>
        <rect
          x="143"
          y="202"
          width="7"
          height="13.5283"
          rx="3.5"
          fill="#9B9DA2"
          fillOpacity="0.19"
        />
        <g filter="url(#4-top-2-3filter4_d)">
          <rect x="143.702" y="202.644" width="5.6" height="12.2399" rx="2.8" fill="#E8EAEE" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M144.286 213.795C144.798 214.458 145.6 214.884 146.502 214.884C148.049 214.884 149.302 213.63 149.302 212.084V205.444C149.302 204.456 148.79 203.587 148.017 203.089C148.383 203.562 148.601 204.155 148.601 204.8V211.44C148.601 212.986 147.347 214.24 145.801 214.24C145.243 214.24 144.723 214.077 144.286 213.795Z"
          fill="#DFE0E2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M146.502 202.644C144.956 202.644 143.702 203.898 143.702 205.444V211.44C143.702 211.46 143.702 211.48 143.703 211.501V206.024C143.703 204.477 144.956 203.224 146.503 203.224C148.029 203.224 149.27 204.444 149.302 205.963V205.444C149.302 203.898 148.049 202.644 146.502 202.644Z"
          fill="#FBFBFB"
        />
        <g filter="url(#4-top-2-3filter5_d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M146.5 206C145.672 206 145 206.672 145 207.5V207.714V209V227.5C145 228.328 145.672 229 146.5 229C147.328 229 148 228.328 148 227.5V211V207.5L148 207.286C148 206.576 147.424 206 146.714 206C146.677 206 146.64 206.001 146.604 206.004C146.569 206.001 146.535 206 146.5 206Z"
            fill="#E8EAEE"
          />
        </g>
        <path d="M44.5 141.959L44.5 274.041L139.126 208L44.5 141.959Z" stroke="white" />
        <path d="M139.29 274.5H44.7102L92 142.483L139.29 274.5Z" stroke="white" />
        <defs>
          <filter
            id="4-top-2-3filter0_d"
            x="25.1201"
            y="252.12"
            width="10.6396"
            height="28.6397"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="0.93994" dy="0.93994" />
            <feGaussianBlur stdDeviation="1.40991" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.256181 0 0 0 0 0.256898 0 0 0 0 0.258333 0 0 0 0.56 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="4-top-2-3filter1_d"
            x="26.1201"
            y="136.12"
            width="9.63962"
            height="25.6396"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="0.93994" dy="0.93994" />
            <feGaussianBlur stdDeviation="1.40991" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.256181 0 0 0 0 0.256898 0 0 0 0 0.258333 0 0 0 0.56 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="4-top-2-3filter2_d"
            x="27.3003"
            y="123.3"
            width="131.279"
            height="170.279"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="0.93994" dy="0.93994" />
            <feGaussianBlur stdDeviation="2.81982" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="4-top-2-3filter3_i"
            x="43"
            y="139"
            width="98.9399"
            height="139.82"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.93994" dy="2.81982" />
            <feGaussianBlur stdDeviation="1.87988" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
          </filter>
          <filter
            id="4-top-2-3filter4_d"
            x="141.822"
            y="200.764"
            width="11.2396"
            height="17.8795"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="0.93994" dy="0.93994" />
            <feGaussianBlur stdDeviation="1.40991" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.256181 0 0 0 0 0.256898 0 0 0 0 0.258333 0 0 0 0.56 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="4-top-2-3filter5_d"
            x="143.12"
            y="204.12"
            width="8.63964"
            height="28.6396"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="0.93994" dy="0.93994" />
            <feGaussianBlur stdDeviation="1.40991" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.256181 0 0 0 0 0.256898 0 0 0 0 0.258333 0 0 0 0.56 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <linearGradient
            id="4-top-2-3paint0_linear"
            x1="25.2"
            y1="262.625"
            x2="32.8"
            y2="262.625"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.340644" stopColor="#E0E0E1" />
            <stop offset="0.630803" stopColor="white" />
            <stop offset="1" stopColor="#E0E2E6" />
          </linearGradient>
          <linearGradient
            id="4-top-2-3paint1_linear"
            x1="23.5"
            y1="274.604"
            x2="33"
            y2="274.604"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.340644" stopColor="#E0E0E1" />
            <stop offset="0.630803" stopColor="white" />
            <stop offset="1" stopColor="#E0E2E6" />
          </linearGradient>
          <linearGradient
            id="4-top-2-3paint2_linear"
            x1="34.8"
            y1="155.5"
            x2="27.2"
            y2="155.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E0E0E1" />
            <stop offset="0.999276" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="4-top-2-3paint3_linear"
            x1="25.2018"
            y1="140.5"
            x2="32.7998"
            y2="140.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.340644" stopColor="#E0E0E1" />
            <stop offset="0.630803" stopColor="white" />
            <stop offset="1" stopColor="#E0E2E6" />
          </linearGradient>
          <linearGradient
            id="4-top-2-3paint4_linear"
            x1="34.7982"
            y1="155.5"
            x2="27.2002"
            y2="155.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.340644" stopColor="#E0E0E1" />
            <stop offset="0.630803" stopColor="white" />
            <stop offset="1" stopColor="#E0E2E6" />
          </linearGradient>
          <linearGradient
            id="4-top-2-3paint5_linear"
            x1="6.79822"
            y1="4.16667"
            x2="-0.799791"
            y2="4.16667"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.340644" stopColor="#E0E0E1" />
            <stop offset="0.630803" stopColor="white" />
            <stop offset="1" stopColor="#E0E2E6" />
          </linearGradient>
        </defs>
      </svg>
    </ProductImageWrapper>
  )
}
